import ServiceOutline from '@pages/Beneficiary-block/WomenComponent/ANC/CommonOutline/AddServiceOutline';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { getData, getDataWithCache, postDataJSON } from '@services/CommonApiService';
import { getLatestServiceAvailedDateByBenefId } from '@services/beneficiaryApiServices';
import endpoints from '@config/endpoints';
import './index.css';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import { areDatesSame, desiredFormatDate, feildValidation, formateDateToTimeStamp, isServiceThroughSession } from '@utils/commonUtils';
import FormatDate from '@utils/dateFormat';
import dayjs from 'dayjs';
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import { fetchDeathReasonOtherThanAEFI, fetchDeathRelatedInformationOptions, fetchDiarrheaTreatment, fetchHavingPneumonia, fetchPlaceOfDeath, fetchProbableCauseOfDeath } from '../NewBorn/NewBornForm/NewBornInitialFetch';
import { COMMON_CONSTANTS, DeathDetailsData, DeathDetailsInitialValues, sickChildCareData, sickChildCareDataInitialValues } from './SickChildCareConstant';
import { BREAD_SCRUMB_CONSTANTS, FIELD_CONSTANTS, messages, ServiceReportCodeForChild, COMMON_CONSTANTS as NEWBORN_COMMON_CONSTANTS } from '../NewBorn/NewBornForm/NewBornConstants';
import { PNC_CHILD_COMMON_CONSTANTS } from '@pages/Beneficiary-block/WomenComponent/PNC/PNCConstants';
import { status_type } from '@constants/vhndExecutionConstant';
import AlertPopup from '@pages/Beneficiary-block/WomenComponent/CreateNewChild/AlertPopup';
import { useDispatch } from 'react-redux';
import { updatePNC } from '@store/actions/beneficiaryAction';
import { dateFormate } from '@constants/index';
import DeceasedPopup from './DeceasedPopup';
import Spinner from '@components/common/Spinner';
interface objectType {
    isError: boolean;
    message: string;
    isDisable: boolean;
    value: any;
    reportId?: any;
    serviceId?: any;
    code?: any;
    option?: any;
}
export interface formStateType {
    [key: string]: objectType;
}

const SickChildCare = () => {

    const [sickChildCareFormData, setsickChildCareFormData] = useState<any>(sickChildCareData)
    const [sickChildCareFormState, setsickChildCareFormState] = useState<any>(sickChildCareDataInitialValues)
    const [showDeceasedModal, setShowDeceasedModal] = useState<boolean>(false);
    const [navItemsModal, setNavItemsModal] = useState([COMMON_CONSTANTS.SICK_CHILD_CARE_DETAILS])
    const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
    const [backDatedResponse, setBackDatedResponse] = useState<any>([]);
    const [latestServiceDate, setLatestServiceDate] = useState<any>(null);
    const [backDatedFormDetails, setBackDatedFormDetails] = useState<any>(sickChildCareDataInitialValues);
    const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails);
    const isEditButtonClicked = useSelector((state: RootState) => state.beneficiary.isEditButtonClicked,);
    const sickChildCareVisitDate = useSelector((state: RootState) => state.beneficiary.sickChildCareVisitDate);
    const benfDetails = useSelector((state: RootState) => state.beneficiary.childDetails,);
    const [formCompleted, setFormCompleted] = useState<boolean[]>(Array(navItemsModal.length).fill(false),);
    const [modalTitle, setModalTitle] = useState<string>('');
    const eventExecution = useSelector((state: RootState) => state.eventExution);
    const [actionSource, setActionSource] = useState('');
    const navigateWithMenuItem = useNavigateWithMenuItem();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [selectPerc, setSelectedPerc] = useState<any>(0);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const dateOfBirth = childDetails?.dob;
    const navs = 100 / navItemsModal.length;
    const vhndDetails = isServiceThroughSession(eventExecution);
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const initialFetch = async () => {
        setLoader(true);
        await fetchDiarrheaTreatment(setsickChildCareFormData);
        await fetchDeathRelatedInformationOptions(setsickChildCareFormData)
        await fetchHavingPneumonia(setsickChildCareFormData);
        await fetchProbableCauseOfDeath(setsickChildCareFormData, FormatDate(benfDetails?.dob))
        await fetchPlaceOfDeath(setsickChildCareFormData)
        await getBackDatedEntry();

        // const latestServiceRes = await getLatestServiceAvailedDateByBenefId(childDetails?.benef_id);
        // const latestAvailedDate = latestServiceRes?.data?.[0]?.get_latest_service_availed_date_for_benef;
        // setLatestServiceDate(latestAvailedDate ? dayjs(latestAvailedDate) : null);
        setLoader(false);
    };
    
    const getBackDatedEntry = async () => {
        try {
            const res = await getData<any>(`${endpoints.CompletedServiceList}/${childDetails?.benef_id}`);
               if (res?.data.length === 0) {
                return;
            }

            const sickChildCareRecords = res?.data?.filter((item: any) =>
                item.service_code === ServiceReportCodeForChild.diarrheaTreatment ||
                item.service_code === ServiceReportCodeForChild.havingPneumonia
            );

            let targetVisitDate: string | null = null;

            const visitDateToMatch = isEditButtonClicked
                ? sickChildCareVisitDate
                : currentFacilityDetails?.visitDate;

                if (visitDateToMatch) {
                    const storedDate = new Date(visitDateToMatch).getTime();
                    const matchingRecords = sickChildCareRecords?.filter((item: any) =>
                        item.visit_date && new Date(item.visit_date).getTime() === storedDate
                    );
                    if (matchingRecords.length > 0) {
                        targetVisitDate = matchingRecords[0].visit_date;
                    }
                }

                if (!targetVisitDate) {
                    if (!isEditButtonClicked) return; // no matching date for new service → clean form
                    targetVisitDate = sickChildCareRecords.reduce((latest: string | null, item: any) => {
                        if (!latest || (item.visit_date && new Date(item.visit_date) > new Date(latest))) {
                            return item.visit_date;
                        }
                        return latest;
                    }, null);
                }

            const targetSickChildRecords = sickChildCareRecords.filter((item: any) => item.visit_date === targetVisitDate);

            setBackDatedResponse(res?.data);

            const isHavingOptions = targetSickChildRecords.length > 0;

            if (isHavingOptions)  {
                const initialState: any = {};
                Object.keys(JSON.parse(JSON.stringify(sickChildCareData))).forEach((key) => {
                    initialState[key] = { value: null, id: null, code: null };
                });

                const updatedFormState = targetSickChildRecords.reduce((acc: any, item: any) => {
                    const value = item.service_report;
                    const serviceCode = item.service_code;

                    switch (serviceCode) {
                        case ServiceReportCodeForChild.diarrheaTreatment:
                            acc.diarrheaTreatment = {
                                value: value,
                                id: item.service_report_id,
                                code: item.service_code,
                                isError: false,
                                message: ''
                            };
                            break;
                        case ServiceReportCodeForChild.havingPneumonia:
                            acc.havingPneumonia = {
                                value: value,
                                id: item.service_report_id,
                                code: item.service_code,
                                isError: false,
                                message: ''
                            };
                            break;
                        default:
                            break;
                    }
                    return acc;
                }, initialState);

                updatedFormState.deathRelatedInformation = {
                    value: 'No',
                    isError: false,
                    message: ''
                };

                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    ...updatedFormState
                }));

                setBackDatedFormDetails((prev: any) => ({
                    ...prev,
                    ...updatedFormState
                }));
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
        }
    };

    useEffect(() => {
        initialFetch();
    }, []);

     const getSickChildOptions =  (backDatedResponse:any) => {
        const sickChildRecords = backDatedResponse?.filter((item: any) => item.service_code === ServiceReportCodeForChild.diarrheaTreatment || item.service_code === ServiceReportCodeForChild.havingPneumonia);
        if (sickChildCareVisitDate && sickChildRecords?.length > 0) {
            const storedDate = new Date(sickChildCareVisitDate).getTime();
            const matchingRecord = sickChildRecords?.find((item: any) => item.visit_date && new Date(item.visit_date).getTime() === storedDate);
            if (matchingRecord) return matchingRecord;
        }
        return sickChildRecords?.[0];
    }

    useEffect(() => {
        if (sickChildCareFormState.deathRelatedInformation.value === 'Yes') {

            setsickChildCareFormState((prevState: any) => ({
                ...prevState,
                ...DeathDetailsInitialValues
            }));


            setsickChildCareFormData((prevState: any) => {

                const mergedData: any = { ...prevState };
                Object.keys(DeathDetailsData).forEach(key => {
                    mergedData[key] = {
                        ...prevState[key],
                        ...DeathDetailsData[key]
                    };
                });
                return mergedData;
            });

            const sickChildOption = isEditButtonClicked ? getSickChildOptions(backDatedResponse) : null;
            const maxDeathDate = sickChildOption?.visit_date || currentFacilityDetails?.visitDate;
            const nonSickChildServiceCodes = [
                ServiceReportCodeForChild.diarrheaTreatment,
                ServiceReportCodeForChild.havingPneumonia
            ];
            const latestNonSickChildDate = backDatedResponse
                ?.filter((item: any) => item?.visit_date && !nonSickChildServiceCodes.includes(item.service_code))
                .reduce((latest: dayjs.Dayjs | null, item: any) => {
                    const currentDate = dayjs(item.visit_date);
                    if (!latest || currentDate.isAfter(latest, 'day')) {
                        return currentDate;
                    }
                    return latest;
                }, null);

            const minDeathDate = latestNonSickChildDate
                ? (maxDeathDate && dayjs(maxDeathDate).isBefore(latestNonSickChildDate, 'day')
                    ? dayjs(maxDeathDate)
                    : latestNonSickChildDate)
                : dateOfBirth;
            setsickChildCareFormData((prevState: any) => ({
                ...prevState,
                date_of_death: {
                    ...prevState?.date_of_death,
                    '#minDate': minDeathDate,
                    '#maxDate': maxDeathDate
                },
            }));

            fetchDeathReasonOtherThanAEFI(setsickChildCareFormData);
            fetchProbableCauseOfDeath(setsickChildCareFormData, FormatDate(benfDetails?.dob))
            fetchPlaceOfDeath(setsickChildCareFormData)

            const aefiReportItems = backDatedResponse?.filter((item: any) => item.service_code === ServiceReportCodeForChild.aefiReported);

            const isNoAefiSelected = backDatedResponse?.some((item: any) =>
                item.service_code === ServiceReportCodeForChild.aefiReported &&
                String(item?.service_report || '').toLowerCase() === NEWBORN_COMMON_CONSTANTS.NO_AEFI.toLowerCase()
            );

            if (isNoAefiSelected) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    deathHappenedDueTo: {
                        ...prevState.deathHappenedDueTo,
                        value: COMMON_CONSTANTS.DEATH_DUE_TO_OTHER_THAN_AEFI,
                        isError: false,
                        message: ''
                    }
                }));

                setsickChildCareFormData((prevState: any) => ({
                    ...prevState,
                    deathHappenedDueTo: {
                        ...prevState.deathHappenedDueTo,
                        '#isDisabled': true
                    },
                    probableCauseOfDeath: {
                        ...prevState.probableCauseOfDeath,
                        '#isDisabled': false,
                        '#required': true
                    }
                }));
            } else {
                setsickChildCareFormData((prevState: any) => ({
                    ...prevState,
                    deathHappenedDueTo: {
                        ...prevState.deathHappenedDueTo,
                        '#isDisabled': false
                    }
                }));
            }
        } else {

            setsickChildCareFormState((prevState: any) => {
                const newState = { ...prevState };

                delete newState.deathHappenedDueTo;
                delete newState.date_of_death;
                delete newState.timeOfDeath;
                delete newState.probableCauseOfDeath;
                delete newState.placeOfDeath;
                delete newState.death_notification_sent_by_asha_with_24hrs;
                delete newState.fbir_completed_by_anm;
                return newState;
            });

            setsickChildCareFormData((prevState: any) => {
                const newData = { ...prevState };

                delete newData.deathHappenedDueTo;
                delete newData.date_of_death;
                delete newData.timeOfDeath;
                delete newData.probableCauseOfDeath;
                delete newData.placeOfDeath;
                delete newData.death_notification_sent_by_asha_with_24hrs;
                delete newData.fbir_completed_by_anm;
                return newData;
            });
        }
    }, [sickChildCareFormState.deathRelatedInformation.value,backDatedResponse]);

    const handlesickChildCareForm = (value: any, key: string, id: any, dataOptions: any, code: any, changedData?: any, label?: any) => {

        setsickChildCareFormState((prevState: any) => {
            if (key === FIELD_CONSTANTS.DEATH_HAPPENED_DUE_TO) {
                setsickChildCareFormData((prevDataState: any) => {
                    if (value === COMMON_CONSTANTS.DEATH_DUE_TO_OTHER_THAN_AEFI) {
                        return {
                            ...prevDataState,
                            probableCauseOfDeath: {
                                ...prevDataState.probableCauseOfDeath,
                                '#isDisabled': false,
                                '#required': true,
                            },
                        };
                    } else {
                        return {
                            ...prevDataState,
                            probableCauseOfDeath: {
                                ...prevDataState.probableCauseOfDeath,
                                '#isDisabled': true,
                                '#required': false,
                            },
                        };
                    }
                });

                return {
                    ...prevState,
                    deathHappenedDueTo: {
                        ...prevState.deathHappenedDueTo,
                        value: value,
                        isError: false,
                        message: '',
                    },
                    probableCauseOfDeath: {
                        ...prevState.probableCauseOfDeath,
                        value:
                            value === COMMON_CONSTANTS.DEATH_DUE_TO_OTHER_THAN_AEFI
                                ? prevState.probableCauseOfDeath.value
                                : '',
                        isError: false,
                        message: '',
                    },
                };
            }

            return {
                ...prevState,
                [key]: {
                    ...prevState[key],
                    value: value,
                    isError: false,
                    message: ''
                }
            };
        });
        if (key === FIELD_CONSTANTS.DATE_OF_DEATH) {
            if (value) {
                if (areDatesSame(value, dateOfBirth, 'days')) {
                    setsickChildCareFormData((prevState: any) => ({
                        ...prevState,
                        timeOfDeath: {
                            ...prevState.timeOfDeath,
                            '#minTime': dayjs(dateOfBirth),
                            '#isDisabled': false,
                        },
                    }));
                    setsickChildCareFormState((prevState: any) => ({
                        ...prevState,
                        timeOfDeath: {
                            ...prevState.timeOfDeath,
                            value: '',
                        }
                    }))
                } else {
                    setsickChildCareFormData((prevState: any) => ({
                        ...prevState,
                        timeOfDeath: {
                            ...prevState.timeOfDeath,
                            '#minTime': '',
                            '#isDisabled': false,
                        },
                    }));
                    setsickChildCareFormState((prevState: any) => ({
                        ...prevState,
                        timeOfDeath: {
                            ...prevState.timeOfDeath,
                            value: '',
                        }
                    }))
                }
            } else {
                setsickChildCareFormData((prevState: any) => ({
                    ...prevState,
                    timeOfDeath: {
                        ...prevState.timeOfDeath,
                        '#minTime': '',
                        '#isDisabled': true,
                    },
                }));
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    timeOfDeath: {
                        ...prevState.timeOfDeath,
                        value: '',
                    }
                }))
            }
        }
    }

    const getServiceIdByValue = (options: any[], value: string) => {
        try {
            const foundOption = options.find(option => option.value === value);
            return foundOption ? foundOption.serviceId : null;
        }
        catch (error: any) {
            errorLogger(error)
        }
    };


    const getReportIdByValue = (options: any[], value: string) => {
        try {
            const foundOption = options.find(option => option.value === value);
            return foundOption ? foundOption.reportId : null;
        }
        catch (error: any) {
            errorLogger(error)
        }
    };


    const contents = [
        <div key="Service">
         {loader? <Spinner /> :
            <form className="skin-care-form-container">
                <CommonFormFields
                    formData={sickChildCareFormData}
                    formState={sickChildCareFormState}
                    handleFormChange={handlesickChildCareForm}
                />
            </form>}
        </div>,
    ];

    const handleFormError = () => {
        let checkError = false;
        if (!sickChildCareFormState.diarrheaTreatment.value) {
            setsickChildCareFormState((prevState: any) => ({
                ...prevState,
                diarrheaTreatment: {
                    ...prevState.diarrheaTreatment,
                    isError: true,
                    message: messages.validOptionsErrorMessage
                },
            }));
            checkError = true;
        }

        if (!sickChildCareFormState?.deathRelatedInformation?.value) {
            setsickChildCareFormState((prevState: any) => ({
                ...prevState,
                deathRelatedInformation: {
                    ...prevState.deathRelatedInformation,
                    isError: true,
                    message: messages.validOptionsErrorMessage
                },
            }));
            checkError = true;
        }

        if (sickChildCareFormState.deathRelatedInformation.value === 'Yes') {
            if (!sickChildCareFormState?.probableCauseOfDeath?.value && sickChildCareFormData?.probableCauseOfDeath?.['#required']) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    probableCauseOfDeath: {
                        ...prevState.probableCauseOfDeath,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.deathHappenedDueTo?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    deathHappenedDueTo: {
                        ...prevState.deathHappenedDueTo,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.date_of_death?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    date_of_death: {
                        ...prevState.date_of_death,
                        isError: true,
                        message: messages.validDateErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.timeOfDeath?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    timeOfDeath: {
                        ...prevState.timeOfDeath,
                        isError: true,
                        message: messages.validTimeErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.probableCauseOfDeath?.value && sickChildCareData?.probableCauseOfDeath?.['#required']) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    probableCauseOfDeath: {
                        ...prevState.probableCauseOfDeath,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }

            if (!sickChildCareFormState?.death_notification_sent_by_asha_with_24hrs?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    death_notification_sent_by_asha_with_24hrs: {
                        ...prevState.death_notification_sent_by_asha_with_24hrs,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.placeOfDeath?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    placeOfDeath: {
                        ...prevState.placeOfDeath,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }
            if (!sickChildCareFormState?.fbir_completed_by_anm?.value) {
                setsickChildCareFormState((prevState: any) => ({
                    ...prevState,
                    fbir_completed_by_anm: {
                        ...prevState.fbir_completed_by_anm,
                        isError: true,
                        message: messages.validOptionsErrorMessage
                    },
                }));
                checkError = true;
            }
        }
        return checkError;
    };

    const closeAlertModal = (value: boolean, title: any, action: any) => {

        if (value) {
            setAlertModalOpen(false);
            const serviceDetails = {
                currRoute: currentFacilityDetails?.currRoute,
            };
            if (action === 'back') {
                if (isEditButtonClicked) {
                    dispatch(updatePNC('currentFacilityDetails', {}));
                    navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
                } else {
                    navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
                }
            } else {
                navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
            }
        } else {
            setAlertModalOpen(false);
        }
    };

    const isChildDead = () => {
        return sickChildCareFormState.deathRelatedInformation.value === status_type.yes.status_name;
    }

    const handleSubmit = async () => {
        setLoader(true);
        const isFormError = handleFormError();
        //only use sickChildOption for edit flow — in new flow always use currentFacilityDetails
        const sickChildOption = isEditButtonClicked ? getSickChildOptions(backDatedResponse) : null;
        if (!isFormError) {
            try {
                const childPncPayload = {
                    benefId: childDetails?.benef_id,
                    facilityId: isEditButtonClicked
                        ? (sickChildOption?.facility_id || currentFacilityDetails?.facilityId)
                        : currentFacilityDetails?.facilityId,
                    healthProviderId: isEditButtonClicked
                        ? (sickChildOption?.healthprovider_id || currentFacilityDetails?.healthProviderId)
                        : currentFacilityDetails?.healthProviderId,
                    mobiliserId: isEditButtonClicked
                        ? (sickChildOption?.mobiliser_id || currentFacilityDetails?.mobilizerId)
                        : currentFacilityDetails?.mobilizerId,
                    sessionId: vhndDetails?.sessionId || null,
                    vhndExecutionId: vhndDetails?.executionId || null,
                    visitDate: isEditButtonClicked && sickChildOption?.visit_date
                    ? dayjs(sickChildOption?.visit_date).format('YYYY-MM-DD')
                    : dayjs(currentFacilityDetails?.visitDate).format('YYYY-MM-DD'),
                    diarrheaTreatmentIfAnyServiceId: getServiceIdByValue(sickChildCareFormData.diarrheaTreatment['#options'], sickChildCareFormState.diarrheaTreatment.value),
                    diarrheaTreatmentIfAnyReportId: getReportIdByValue(sickChildCareFormData.diarrheaTreatment['#options'], sickChildCareFormState.diarrheaTreatment.value),
                    isTheChildHavingPneumoniaServiceId: getServiceIdByValue(sickChildCareFormData.havingPneumonia['#options'], sickChildCareFormState.havingPneumonia.value),
                    isTheChildHavingPneumoniaReportId: getReportIdByValue(sickChildCareFormData.havingPneumonia['#options'], sickChildCareFormState.havingPneumonia.value),
                    isDeathHappened: isChildDead(),
                    probableCauseOfDeathId: isChildDead() ? getReportIdByValue(sickChildCareFormData?.probableCauseOfDeath['#options'], sickChildCareFormState?.probableCauseOfDeath?.value) : null,
                    dateOfDeath: isChildDead() ? formateDateToTimeStamp(sickChildCareFormState?.date_of_death?.value, sickChildCareFormState?.timeOfDeath?.value) : null,
                    placeOfDeathId: isChildDead() ? getReportIdByValue(sickChildCareFormData?.placeOfDeath['#options'], sickChildCareFormState?.placeOfDeath?.value) || null : null,
                    notificationSentByAshaWith24Hrs: isChildDead() ? sickChildCareFormState?.death_notification_sent_by_asha_with_24hrs?.value === status_type.yes.status_name ? true : false : null,
                    fbirCompletedByAnm: isChildDead() ? sickChildCareFormState?.fbir_completed_by_anm?.value === status_type.yes.status_name ? true : false : null,
                    deathReasonId: isChildDead() ? getReportIdByValue(sickChildCareFormData?.deathHappenedDueTo['#options'], sickChildCareFormState?.deathHappenedDueTo?.value) || null : null,
                    parentUserId: localStorage.getItem('userId')
                }


                const res = await postDataJSON<any>(`${endpoints.createSkiniCare}`, childPncPayload);

                if (!res?.data[0]?.error_msg) {
                    const newFormCompleted = [...formCompleted];
                    newFormCompleted[activeIndex] = true;
                    setFormCompleted(newFormCompleted);
                    const perc = (activeIndex + 1) * navs;
                    setSelectedPerc(perc);

                    dispatch(updatePNC('currentFacilityDetails', {}));
                    navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
                    toast.success(COMMON_CONSTANTS.successMessage, {
                        position: "top-center"
                    });
                }
                else {
                    toast.error(COMMON_CONSTANTS.somethingWentWrong, {
                        position: "top-center"
                    });
                }
            } catch (error: any) {
                toast.error(COMMON_CONSTANTS.somethingWentWrong, {
                    position: "top-center"
                });
                errorLogger(error?.response?.data || error?.response || error);
            }
        } else {
            const newFormCompleted = [...formCompleted];
            newFormCompleted[activeIndex] = false;
            setFormCompleted(newFormCompleted);
            const perc = (activeIndex - 1) * navs;
            setSelectedPerc(perc);

        }
        setLoader(false);
    }

    const handleCancel = () => {
        setActionSource('cancel');
        setModalTitle(PNC_CHILD_COMMON_CONSTANTS.MODAL_TITLE);
        setAlertModalOpen(true);
    };

    const isFormChanged = (sickChildCareFormState: any) => {
        const baseObject = backDatedResponse.length > 0 ? backDatedFormDetails : sickChildCareDataInitialValues;
        for (const key in sickChildCareDataInitialValues) {
            if (sickChildCareFormState[key].value !== baseObject[key]?.value) {
                return true;
            }
        }
        return false;
    };

    const breadcrumbItemName = [
        { value: 0, label: BREAD_SCRUMB_CONSTANTS.SERVICE_PROVIDER },
        { value: 0, label: BREAD_SCRUMB_CONSTANTS.BENEFICIARY_PROFILE },
    ]

    const handleBack = () => {
        setActionSource('back');
        if (isFormChanged(sickChildCareFormState)) {
            setModalTitle(PNC_CHILD_COMMON_CONSTANTS.CHANGES_MODAL_TITLE);
            setAlertModalOpen(true);
            return;
        }
        const serviceDetails = {
            currRoute: currentFacilityDetails?.currRoute,
        };
        if (!isEditButtonClicked) {
            navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
        } else {
            navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
        }
    }

    const closeDeceasedModal = (value: boolean) => {
        setShowDeceasedModal(false);
        if (value) {
            handleSubmit();
        }
    };


    return (
        <div>
            <ServiceOutline
                breadcrumbItemName={breadcrumbItemName}
                onHandleBackArrowButton={handleBack}
                navItemsModal={navItemsModal}
                activeIndex={activeIndex}
                formCompleted={[false]}
                headerName={COMMON_CONSTANTS.SICK_CHILD_CARE}
                progressBarPerc={selectPerc}
                contents={contents}
                finishHandler={() => isChildDead() ? setShowDeceasedModal(true) : handleSubmit()}
                handleCancel={handleCancel}
                title={COMMON_CONSTANTS.TITLE}
            />
            <AlertPopup
                showModal={alertModalOpen}
                closeModal={(value: boolean) =>
                    closeAlertModal(value, modalTitle, actionSource)
                }
                title={modalTitle}
            />
            <DeceasedPopup
                showModal={showDeceasedModal}
                closeModal={closeDeceasedModal}
                title={COMMON_CONSTANTS.DECEASED_CONFIRMATION_TITLE}
            />
        </div>
    );
}

export default SickChildCare;
